import { imageExtensionPattern } from "@/frontend/shared/const/regexPatterns";

export function validateLogo({
  url,
  maxLength,
  fieldName = "Image URL",
  required = true
}: {
  url: string;
  maxLength?: number;
  fieldName?: string;
  required?: boolean;
}): string | undefined {
  if (!url) {
    if (required) return `${fieldName} is required.`;
    return undefined;
  }

  if (maxLength && url.length > maxLength) {
    return `${fieldName} must not exceed ${maxLength} characters.`;
  }
  if (!imageExtensionPattern.test(url)) return `Invalid file type (must be PNG/JPG/JPEG).`;
}
